import {
   // getMediaComments,
   getMediaCommentsByFilter,
   mediaCommentLike,
   mediaCommentDelete,
   sendMediaComment,
}  from 'sites/api/MixApi';

import {
   fetchMediaCommentsRequest,
   fetchMediaCommentsCompleted,
   fetchMediaCommentsFailed,

   fetchCommentsByFilterRequest,
   fetchCommentsByFilterCompleted,
   fetchCommentsByFilterFailed,

   fetchNewCommentsRequest,
   fetchNewCommentsCompleted,
   fetchNewCommentsFailed,

   commentLikeRequest,
   commentLikeCompleted,
   commentLikeFailed,

   commentDeleteRequest,
   commentDeleteCompleted,
   commentDeleteFailed,

   sendCommentRequest,
   sendCommentCompleted,
   sendCommentFailed,
} from "./actions";
import toast from "common/utils/toast";

export const getMediaCommentsOperation = (id, type, commentsCount, param = []) => {
   return async (dispatch) => {
      dispatch(fetchMediaCommentsRequest())
      try {
         const response = await getMediaCommentsByFilter(id, param, type);
         dispatch(fetchMediaCommentsCompleted(response.data, commentsCount))
      } catch (error) {
         if(error){
            dispatch(fetchMediaCommentsFailed(error.response))
         }
      }
   };
};

export const getMediaCommentsByFilterOperation = (id, query, type, callBack) => {
   return async (dispatch) => {
      dispatch(fetchCommentsByFilterRequest())
      try {
         const response = await getMediaCommentsByFilter(id, query, type);
         dispatch(fetchCommentsByFilterCompleted(response.data))
         if(callBack) callBack('succeed')
      } catch (error) {
         dispatch(fetchCommentsByFilterFailed(error))
         if(callBack) callBack('failed')
      }
   };
};

export const commentLikeOperation = (id, commentId, parentId, type) => {
   return async (dispatch) => {
      dispatch(commentLikeRequest())
      try {
         await mediaCommentLike(id, commentId, type);
         dispatch(commentLikeCompleted({ commentId, parentId }))
      } catch (error) {
         dispatch(commentLikeFailed(error))
      }
   };
};

export const commentDeleteOperation = (id, commentId, parentId, type) => {
   return async (dispatch) => {
      dispatch(commentDeleteRequest())
      try {
         await mediaCommentDelete(id, commentId, type);
         dispatch(commentDeleteCompleted({ commentId, parentId }))
      } catch (error) {
         dispatch(commentDeleteFailed(error))
      }
   };
};

export const getNewCommentsOperation = (id, query, type, isInsideModal) => {
   return async (dispatch) => {
      dispatch(fetchNewCommentsRequest())
      try {
         const response = await getMediaCommentsByFilter(id, query, type);
         dispatch(fetchNewCommentsCompleted(response.data, isInsideModal))
      } catch (error) {
         console.log(error);
         dispatch(fetchNewCommentsFailed(error))
      }
   };
};

export const sendCommentOperation = (data, type, isInsideModal) => {
   return async (dispatch) => {
      dispatch(sendCommentRequest());
      try {
         const response = await sendMediaComment(data, type);
         dispatch(sendCommentCompleted(response.data, isInsideModal))
         // if(!!data.parent_id) {
         //    const element = document.getElementById('comments-list')
         //    element.scrollTo({
         //       top: document.getElementById('activeReply').offsetTop,
         //       left: 0,
         //       behavior: 'smooth',
         //    });
         // }
         if(!!isInsideModal) {
            setTimeout(() => {
               const element = document.getElementById('comments-list')
               if(element) {
                  element.scrollTo({ top: element.scrollHeight, left: 0, behavior: 'smooth' })
               }
            }, 200)
         }
         toast.info('Your comment has been posted')
      } catch (error) {
         dispatch(sendCommentFailed(error))
      }
   };
};


